import { render, staticRenderFns } from "./addListApp.vue?vue&type=template&id=f4b11676&scoped=true&"
import script from "./addListApp.vue?vue&type=script&lang=js&"
export * from "./addListApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b11676",
  null
  
)

export default component.exports